export const ANALYTICS_EVENTS = {
    VIRTUAL_PAGE_VIEW: 'virtual_page_view',
    PAYMENT_CONFIRMED: 'pago_confirmado',
    PAYMENT_CASH: 'pago_efectivo',
    PAYMENT_STORE: 'pago_tienda',
    PAYMENT_DESTINATION: 'pago_destino',
    SUMMARY_VIEW: 'vista_resumen_envios'
} as const;

export const ANALYTICS_STORAGE_KEYS = {
    PAYMENT_TRACKED_PREFIX: 'analytics_payment_tracked'
} as const;
